// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__oIu39","overflowing":"ReadFullNote_overflowing__2StEm"};